import { RQ } from 'utils';

export default {
  getInfo: async function () {
    const d = await RQ.mall.get(
      '/api/h5/user/admin/getSummary',
      {
        type: this.type
      }
    );
    if (d && d.code == 0) {
      this.count = d.data;
    } else {
      this.tips(d.msg, 1500);
    }
  },
  getEnterpriseInfo: async function () {
    const d = await RQ.mall.get(
      '/api/h5/user/admin/getEnterpriseSummary',
      {
        type: this.type
      }
    );
    if (d && d.code == 0) {
      this.page = d.data;
    } else {
      this.tips(d.msg, 1500);
    }
  },
  onType: function (index, title) {
    console.info(index);
    this.type = index;
    this.getInfo();
    this.getEnterpriseInfo();
  }
};



// WEBPACK FOOTER //
// ./src/module/summary/admin/action.js